import React, { useRef, useCallback } from 'react';
import Styles from './RangeSelect.css';

function RangeSelect({
  min = 0,
  max = 100,
  value = 0,
  minLabel = 'min',
  maxLabel = 'max',
  onChange,
}) {
  const barRef = useRef(null);

  const calcValue = useCallback(
    (clientX) => {
      const bar = barRef.current;
      if (!bar) return;
      const { left, width } = bar.getBoundingClientRect();
      const ratio = Math.min(Math.max((clientX - left) / width, 0), 1);
      const newValue = Math.round(min + ratio * (max - min));
      if (onChange) onChange(newValue);
    },
    [min, max, onChange],
  );

  const handleMouseDown = useCallback(
    (e) => {
      e.preventDefault();
      calcValue(e.clientX);

      const onMouseMove = (moveEvent) => calcValue(moveEvent.clientX);
      const onMouseUp = () => {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    },
    [calcValue],
  );

  const handleTouchStart = useCallback(
    (e) => {
      const onTouchMove = (moveEvent) => calcValue(moveEvent.touches[0].clientX);
      const onTouchEnd = () => {
        window.removeEventListener('touchmove', onTouchMove);
        window.removeEventListener('touchend', onTouchEnd);
      };

      window.addEventListener('touchmove', onTouchMove);
      window.addEventListener('touchend', onTouchEnd);
    },
    [calcValue],
  );

  const percent = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));

  return (
    <>
      <div className="range-select">
        <div
          className="bar"
          ref={barRef}
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
        >
          <span className="bg" />
          <span
            className="indicator"
            style={{
              width: `${percent}%`,
            }}
          />

          <span className="thumb" style={{ left: `${percent}%` }}>
            <span className="thumb-display" />
          </span>
        </div>

        <div className="values">
          <p>{minLabel}</p>
          <p>{maxLabel}</p>
        </div>
      </div>
      <style jsx>{Styles}</style>
    </>
  );
}

export default RangeSelect;
